/**
 * 화면 구현
 */
import { importScript } from '../../utils';
import SbsPlayerLogger from '../../utils/logger';

customElements.define(
  'sbs-player-loading',
  class extends HTMLElement {
    constructor() {
      super();
      this.visible = false;
    }

    set visible(value) {
      this._visible = value;
      this.render();
    }

    get visible() {
      return this._visible;
    }

    static get observedAttributes() {
      return [];
    }

    async attributeChangedCallback(name, oldValue, newValue) {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    async connectedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    disconnectedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    adoptedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    render() {
      try {
        this.innerHTML = `<div class="loading-type003 style01" style="display: ${
          this.visible ? 'block' : 'none'
        }">
		<div class="loading-box01"><div class="loading01"></div></div>
	</div>`;
        this.styles();
        this.event();
      } catch (error) {
        console.log(error);
      }
    }

    styles() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    event() {
      try {
      } catch (error) {
        console.log(error);
      }
    }
  }
);
